import { take } from "rxjs";
import {
  SharedModule,
  DataService,
  ModalService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import {
  CreateFreeGiftSelectionDocument,
  GetVariantSupplierDocument,
} from "../../generated-graphql/graphql";
import ProductCreateDialogComponent from "../Product-Create-Dialog/product-create.component";

@Component({
  selector: "create-gift",
  standalone: true,
  templateUrl: "./create.component.html",
  imports: [SharedModule],
})
export default class CreateGiftComponent implements OnInit {
  constructor(
    protected dataService: DataService,
    private modalService: ModalService,
    private noti: NotificationService
  ) {}
  ngOnInit(): void {
    // this.dataService.query()
  }
  @Input() productRetailer: string;
  @Input() productArtist: string;
  @Input() productName: string;
  @Input() detailForm: UntypedFormGroup;
  @Output() refetch = new EventEmitter<string>();
  createGift() {
    this.modalService
      .fromComponent(ProductCreateDialogComponent, {
        size: "xl",
        closable: true,
        locals: {
          retailer: this.productRetailer,
          artist : this.productArtist,
          name: this.productName,
          parentForm: this.detailForm
        },
      })
      .subscribe((data) => {
        if(data){
          this.refetch.emit(data)
        }
      });
  }
}
